import { render, staticRenderFns } from "./LandingPopup.vue?vue&type=template&id=498f89a0&scoped=true"
import script from "./LandingPopup.vue?vue&type=script&lang=js"
export * from "./LandingPopup.vue?vue&type=script&lang=js"
import style0 from "./LandingPopup.vue?vue&type=style&index=0&id=498f89a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498f89a0",
  null
  
)

export default component.exports